import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Row from "../../Components/Row";
import logo from "../../assets/images/logo.svg";

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #ffffff;
  line-height: 56px;
`;

const SpanText = styled.span`
  font-weight: 200;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
`;

const Footer = () => {
  return (
    <>
      <Container
        style={{
          marginTop: "40px",
        }}
        id="section-8"
      >
        <Row
          xs="1fr"
          sm="1fr"
          md="1fr 1fr"
          lg="1fr 1fr"
          xl="1fr 1fr"
          style={{
            marginTop: "40px",
            marginBottom: "30px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src={logo} width={"150px"} />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 200,
                textAlign: "right",
                fontSize: "20px",
                color: "#fff",
              }}
            >
              © 2026 Alfred
            </span>{" "}
            <span
              style={{
                fontWeight: 700,
                textAlign: "right",
                textDecoration: "underline",
                fontSize: "15px",
                color: "#fff",
              }}
            >
              contato@alfredchat.com.br
            </span>
          </div>
        </Row>
        <hr style={{ borderColor: "#D9D9D9" }} />
        <Row
          xs="1fr"
          sm="1fr"
          md="1fr"
          lg="1fr"
          xl="1fr"
          style={{
            marginTop: "40px",
            marginBottom: "30px",
            justifyContent: "space-evenly",
            alignItems: "center",
            width: "70%",
            textAlign: "center",

          }}
        >
          <a
            href="/term-of-use"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              color: "#fff",
              textDecoration: "none",
            }}
          >
            Termos de uso
          </a>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
